import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '../Button';
import { Checkbox } from '../Checkbox';
import { TextInput } from '@/components/TextInput';

type FormValues = {
  privacyPolicy: boolean;
  subscribe: boolean;
};

export const NewsletterForm = () => {
  const { control, handleSubmit } = useForm<FormValues>({
    shouldUseNativeValidation: true,
  });

  const { t } = useTranslation();

  return (
    <form
      action={
        'https://newsletter.alubel.com/subscribe/e4b4812c-b9d8-459e-bde2-e455d575bed1'
      }
      className={'newsletter-form'}
      method={'POST'}
    >
      <TextInput name={'first_name'} placeholder={t('NAME')} required />

      <TextInput name={'last_name'} placeholder={t('SURNAME')} required />

      <TextInput
        name={'email'}
        placeholder={t('EMAIL')}
        required
        type={'email'}
      />

      <Controller
        control={control}
        name={'privacyPolicy'}
        render={({ field }) => (
          <Checkbox
            checked={!!field.value}
            onChange={field.onChange}
            name={field.name}
            text={'Ho letto e accetto la policy sulla privacy*'}
            required
          />
        )}
      />

      <Controller
        control={control}
        name={'subscribe'}
        render={({ field }) => (
          <Checkbox
            checked={!!field.value}
            onChange={field.onChange}
            name={field.name}
            text={'Desidero iscrivermi alla newsletter*'}
            required
          />
        )}
      />

      <Button type={'submit'}>{t('SUBSCRIBE')}</Button>
    </form>
  );
};
